import {
    CHANGE_LEADS_STATUS_REQUEST,
    CHANGE_LEADS_STATUS_REQUEST_SUCCESS,
    CHANGE_LEADS_STATUS_REQUEST_FAILURE,
} from '../constants/leads_status.constants';

export const changeLeadsStatusRequest = (_id, status_id, requestParams = {}) => ({
    type: CHANGE_LEADS_STATUS_REQUEST, _id, status_id, requestParams,
});
export const changeLeadsStatusRequestSuccess = (payload) => ({ type: CHANGE_LEADS_STATUS_REQUEST_SUCCESS, payload });
export const changeLeadsStatusRequestFailure = (error) => ({ type: CHANGE_LEADS_STATUS_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/change_lead_status.actions.js